/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formemail_Label1Inputs */

const ja_contact_formemail_label1 = /** @type {(inputs: Contact_Formemail_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const en_contact_formemail_label1 = /** @type {(inputs: Contact_Formemail_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Email`)
};

/**
* | output |
* | --- |
* | "Your Email" |
*
* @param {Contact_Formemail_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formemail_label1 = /** @type {((inputs?: Contact_Formemail_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formemail_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formemail_label1(inputs)
	return en_contact_formemail_label1(inputs)
});
export { contact_formemail_label1 as "contact_formEmail_label" }